// deixado essas regras desabilitadas especificamente para funcionamento do componente
/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */
/* The MIT License (MIT)

Copyright (c) 2014 Nicholas Bollweg <nick.bollweg@gmail.com>

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

import d3 from "d3";

function fishbone(
	fishboneId:number, 
	size:Function, 
	canEdit:boolean,
	canDelete:boolean,
	functions?:{
		onAdd:Function,
		onEdit:Function,
		onDelete:Function,
	}
){  

	const configButtons = {
		x: {
			level_1: 0,
			level_2: 0,
			level_3: 0,
			level_4: 0
		},
		y: {
			level_1: -18,
			level_2: 10,
			level_3: {
				region_up: 0,
				region_down: 15
			},
			level_4: {
				region_up: 5,
				region_down: 7
			}
		}
	};
	// private variables
	const cMargin = 50;
	let cNodes = [] as Array<any>;
	let cLinks = [] as Array<any>;
  
	// d3 selections and related things used in tick function
	let cNode:any;
	let cLink:any;
	let cRoot:any;
    
	const fnArrowId = () => `arrow-${fishboneId}`;
  
	// the children accessor
	const fnChildren = (d:any) => d.children;
  
	// the label accessor
	const fnLabel = (d:any) => {
		let text = d.name;
  
		if (d.nodeId && (d.level !== 0 && d.level !== 1)) {
			if (text && text.length > 20) {
				text = text.substr(0, 20);
				text += "...";
			}
		}
		return text;
	};
  
	// arbitrary "nice" values
	const fnLinkScale = d3.scale.log()
		.domain([1, 5])
		.range([60, 30]);
  
        
	// make longer links for nodes with more children, or of lower depth
	const fnLinkDistance = (d:any) => (d.target.maxChildIdx + 1) * fnLinkScale(d.depth + 1);

	const fnTick = (e:any) => {
		/*
            the primary layout mechanism: a fair amount of the work is done
            by links, but override a lot of it here.

            TODO: enable tweaks to these individual rules
        */

		// this is a "little bit"
		const k = 6 * e.alpha;
		// cache some variables
		const tickSize = fnForce.size();
		const width = tickSize[0];
		const height = tickSize[1];
		// scratch variables for lengthy expressions
		let a;
		let b;
  
		cNodes.forEach((d) => {
			if (d.depth === 0) {
				d.x = width * 1.21;
				d.y = height / 2;
  
				const configPosition6M = [1.3, 1.3, 1.99, 1.99, 4.82, 4.82];
				d.children.forEach((item:any) => {
					const index = item.category - 1;
					item.x = width / configPosition6M[index];
					item.y = width / 26.8;
				});
			}
			// handle the middle... could probably store the root width...
			// if(d.root){ d.x = width - (cMargin + cRoot.getBBox().width); }
			if (d.root) {
				const space = width - (cMargin + cRoot.getBBox().width);
				d.x = space + (width / 4);
			}
			// handle the middle... could probably store the root width...
			// if(d.root){ d.x = width - (cMargin + cRoot.getBBox().width); }
			if(d.tail){ d.x = cMargin; d.y = height / 2; }
  
			// put the first-generation items at the top and bottom
			if(d.depth === 1){
				d.y = d.region === -1 ? cMargin : height - cMargin;
				d.x -= 10 * k;
			}
  
			// vertically-oriented tend towards the top and bottom of the page
			if(d.vertical){ d.y += k * d.region; }
  
			// everything tends to the left
			if(d.depth){ d.x -= k; }
  
			// position synthetic nodes at evently-spaced intervals...
			// TODO: do something based on the calculated size of each branch
			// since we don't have individual links anymore
			if(d.between){
				a = d.between[0];
				b = d.between[1];
  
				d.x = b.x - (1 + d.childIdx) * (b.x - a.x) / (b.maxChildIdx + 1);
				d.y = b.y - (1 + d.childIdx) * (b.y - a.y) / (b.maxChildIdx + 1);
			}
  
		});
  
		// actually apply all changes
		cNode.call(fnNodePosition);
		cLink.call(fnLinePosition);
	};

	// the main workhorse of the layout engine
	const fnForce = d3.layout.force()
		.gravity(0)
		.size([size().width, size().height])
		.linkDistance(fnLinkDistance)
		.chargeDistance([10])
		.on("tick", fnTick);

	const getFishBoneAttr = (operation:"add"|"delete"|"update",type:"icon"|"circle") => {
		const operations = {
			"add":{
				"class": (d:any) => {
					if(d.nodeId && d.level !== 0 && canEdit)
						return d.level !== 1 ? "icon icon-causa btn-nova-causa" : "icon icon-6m btn-nova-causa";
						
					return "oculto";
				},
				"transform": (d:any) => {
					const label = fnLabel(d);
					let textLength = label ? label.length : 0;
					let x;
					if (d.level === 1) {
						if (d.region === -1) {
							x = textLength * 7.5;
							return `translate(${  x  }, ${  configButtons.y.level_1 })`;
						} if (d.region === 1) {
							textLength = d.name.length;
							x = textLength * 7;
							return `translate(${  x  }, 6)`;
						}
					} else if (d.level === 2) {
						x = textLength * -5.5;
						return `translate(${  x  }, ${  configButtons.y.level_2 })`;
            
					} else if (d.level === 3) {
						if (d.region === -1) {
							x = textLength * -1.5;
							return `translate(${  x  }, ${ configButtons.y.level_3.region_up })`;
						} if (d.region === 1) {
							x = textLength * -1.5;
							return `translate(${  x  }, ${  configButtons.y.level_3.region_down })`;
						} 
						return "translate(20, -20)";
                
					} else {
						if (d.region === -1) {
							x = textLength * -1.5;
							return `translate(${  x  }, ${ configButtons.y.level_4.region_up })`;
						} if (d.region === 1) {
							x = textLength * -1.5;
							return `translate(${  x  }, ${  configButtons.y.level_4.region_down  })`;
						} 
					}
					return "translate(20, -20)";
				},
				"xlink:href": type === "icon" ? "#icon-plus" : "#icon-plus-circle"
			},
			"delete":{
				"class":(d:any) => {
					const classe = d.nodeId && (d.level !== 0 && d.level !== 1) && canEdit && canDelete ? "icon icon-causa btn-excluir-causa" : "oculto";
					return classe;
				},
				"transform":(d:any) => {
					const label = fnLabel(d);
					const textLength = label  ? label.length : 0;
					let x;
					if (d.level === 1) {
						return "translate(0, 0)";
					} if (d.level === 2) {
						x = (textLength * -5.5) + 15;
						return `translate(${  x  }, ${  configButtons.y.level_2 })`;
					} if (d.level === 3) {
						if (d.region === -1) {
							x = (textLength * -1.5) + 15;
							return `translate(${  x  }, ${ configButtons.y.level_3.region_up })`;
						} if (d.region === 1) {
							x = (textLength * -1.5) + 15;
							return `translate(${  x  }, ${  configButtons.y.level_3.region_down })`;
						} 
						return "translate(20, -20)";
            
					} 
					if (d.region === -1) {
						x = (textLength * -1.5) + 15;
						return `translate(${  x  }, ${  configButtons.y.level_4.region_up })`;
					} if (d.region === 1) {
						x = (textLength * -1.5) + 15;
						return `translate(${  x  }, ${ configButtons.y.level_4.region_down })`;
					} 
					return "translate(20, -20)";
					
				},
				"xlink:href": type === "icon" ? "#icon-times" : "#icon-times-circle"
			},
			"update":{
				"class": (d:any) => {
					const classe = d.nodeId && (d.level !== 0 && d.level !== 1) && canEdit ? "icon icon-causa btn-alterar-causa" : "oculto";
					return classe;
				},
				"transform": (d:any) => {
					const label = fnLabel(d);
					const textLength = label ? label.length : 0;
					let x;
					if (d.level === 1) {
						return "translate(0, 0)";
					} if (d.level === 2) {
						x = (textLength * -5.5) - 15;
						if(type === "icon")
							return `translate(${  x + 3  }, ${  configButtons.y.level_2 + 2 })`;
                        
						return `translate(${  x  }, ${  configButtons.y.level_2 })`;
					} if (d.level === 3) {
						if (d.region === -1) {
							x = (textLength * -1.5) - 15;
							if(type === "icon")
								return `translate(${  x + 3  }, ${ configButtons.y.level_3.region_up + 2 })`;
							return `translate(${  x  }, 0)`;
						} if (d.region === 1) {
							x = (textLength * -1.5) - 15;
							if(type === "icon")
								return `translate(${  x + 3  }, ${ configButtons.y.level_3.region_down + 2 })`;
							return `translate(${  x  }, 12)`;
						} 
						return "translate(20, -20)";
                
					} 
					if (d.region === -1) {
						x = (textLength * -1.5) - 15;
						if(type === "icon")
							return `translate(${  x + 3  }, ${ configButtons.y.level_4.region_up + 2 })`;
						return `translate(${  x  }, ${ configButtons.y.level_4.region_up })`;
					} if (d.region === 1) {
						x = (textLength * -1.5) - 15;
						if(type === "icon")
							return `translate(${  x + 3  }, ${ configButtons.y.level_4.region_down + 2 })`;
						return `translate(${  x  }, ${ configButtons.y.level_4.region_down })`;
					} 
					return "translate(20, -20)";
					
				},
				"xlink:href": type === "icon" ? "#icon-pencil" :"#icon-edit-circle"
			}
		};
		return operations[operation];
	};
  
	const fb1 = ($:any) => {
		/*
            the d3.fishbone modifier, expecting to be called against an `svg:svg`
            or `svg:g` bound to the root node of a navigable tree, i.e.
        
            d3.select("body").append("svg")
                .datum({name: "foo", children: [{name: "bar"}]})
                .call(d3.fishbone());
        
            in addition to the properties created by `d3.layout.force`, this will
            add some or all of the following properties, none of which are
            guaranteed to be stable, useful, or sane:
        
            - depth       int
            - horizontal  bool
            - vertical    bool
            - root        bool
            - childIdx    int
            - maxChildIdx bool
            - totalLinks  [int]
            - linkCount   int
        */

		// populate the nodes and the links globals as a side effect
		fnBuildNodes($.datum());
  
		// retira links exedentes
		cLinks = cLinks.filter((x) => x.arrow === true);
  
		// set the nodes and the links of the force
		fnForce
			.nodes(cNodes)
			.links(cLinks);
  
		// create the links
		cLink = $.selectAll(".link")
			.data(cLinks);
  
		cLink.enter().append("line");
  
		cLink
			.attr({
				"class": (d:any) => {
					const classe = d.source.nodeFake ? "oculto" : `link link-${  d.depth}`;
					return classe;
				},
				"marker-end": ({arrow}:any) => arrow ? `url(#${fnArrowId()})` : null,
				"data-node": (d:any) => `${d.source.nodeId}`
			});
  
		cLink.exit().remove();

		// establish the node selection
		cNode = $.selectAll(".node").data(cNodes);
  
		// actually create nodes
		cNode.enter().append("g")
			.attr({
				"class":(d:any) => {
					let classe = `node${  d.root ? " root" : ""}`;
					classe += d.nodeFake ? " oculto" : "";
					return classe;
				},
				"data-nodeid": (d:any) => d.nodeId,
				"data-level": (d:any) => d.level,
				"data-category": (d:any) =>  d.category,
				"data-region": (d:any) => d.region
			});
  
		const gNodes = $.selectAll("g").data(cNodes);

		gNodes.append("use").attr(getFishBoneAttr("update","circle")).on("click",(nodeData:any) => functions?.onEdit(nodeData));
		
		gNodes.append("use").attr(getFishBoneAttr("update","icon")).on("click",(nodeData:any) => functions?.onEdit(nodeData));

		gNodes.append("use").attr(getFishBoneAttr("add","icon")).on("click",(nodeData:any) => functions?.onAdd(nodeData));

		gNodes.append("use").attr(getFishBoneAttr("add","circle")).on("click",(nodeData:any) => functions?.onAdd(nodeData));
		
		gNodes.append("use").attr(getFishBoneAttr("delete","icon")).on("click",(nodeData:any) => functions?.onDelete(nodeData));
		
		gNodes.append("use").attr(getFishBoneAttr("delete","circle")).on("click",(nodeData:any) => functions?.onDelete(nodeData));
		
		const div = d3.select(`#fishbone${fishboneId}-tooltip-container`).append("div")	
			.attr("class", "tooltip")				
			.style("opacity", 0)
			.style("display", "none");

		// TEXTO
		gNodes.append("text").attr({
			"class": (d:any) => {
				const classe = d.nodeId && (d.level !== 0 && d.level !== 1) ? `label label-${  d.depth}` : `label-${  d.depth}`;
				return classe;
			},
			"text-anchor": (d:any) => {
				if(!d.depth)
					return "start";
				
				return d.horizontal ? "end" : "middle";
			},
			dy(d:any) {
				if(d.horizontal)
					return ".35em";
				
				return d.region === 1 ? "1em" : "-.2em";
			}
		}).text(fnLabel)
			.on("mouseover", (d:any) => {	
				if(d.level < 2 && d.name && d.name.length < 20) return;	
				div.transition()		
					.duration(200)		
					.style("opacity", .9)
					.style("display", "block");		
				div.html(d.name);
			})		
			.on("mousemove", (d:any) => {
				if(d.level < 2 && d.name && d.name.length < 20) return;	
				div.style("top", `${d.y+175}px`).style("left",`${d.x-10}px`);
			})			
			.on("mouseout", (d:any) => {	
				if(d.level < 2 && d.name && d.name.length < 20) return;		
				div.transition()		
					.duration(500)		
					.style("opacity", 0)
					.style("display", "none");	
			});

		
		cNode.exit().remove();
  
		// select this so we know its width in tick
		cRoot = $.select(".root").node();
	}; // fb1
  
  
	const fnArrow = ($:any) => {
		// creates an svg:defs and marker with an arrow if needed...
		// really just an example, as they aren't very flexible
		const defs = $.selectAll("defs").data([1]);
  
		defs.enter().append("defs");
  
		// create the arrows
		defs.selectAll(`marker#${  fnArrowId()}`)
			.data([1])
			.enter().append("marker")
			.attr({
				class: "fishbone-arrow",
				id: fnArrowId(),
				viewBox: "0 -5 10 10",
				refX: 10,
				refY: 0,
				markerWidth: 10,
				markerHeight: 10,
				orient: "auto"
			})
			.append("path")
			.attr({d: "M0,-5L10,0L0,5"});

		// BOTÃO EDITAR
		defs.append("symbol").attr({
			id: "icon-edit-circle",
			viewBox: "0 0 512 512",
			width: "17px",
			height: "17px",
			fill: "#2283c5"
		}).append("path").attr({
			class: "edit-circle-svg",
			d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
		});

		defs.append("symbol").attr({
			id: "icon-pencil",
			viewBox: "0 0 512 512",
			width: "11px",
			height: "11px",
			fill: "#f6f6f6"
		}).append("path").attr({
			class: "edit-circle-svg",
			d: "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
		});

		// BOTÃO ADICIONAR
		defs.append("symbol").attr({
			id: "icon-plus",
			viewBox: "0 0 512 512",
			width: "17px",
			height: "17px",
			fill: "#f6f6f6"
		}).append("path").attr({
			class: "plus-circle-svg",
			d: "M400 284a12 12 0 0 1-12 12h-92v92a12 12 0 0 1-12 12h-56a12 12 0 0 1-12-12v-92h-92a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h92v-92a12 12 0 0 1 12-12h56a12 12 0 0 1 12 12v92h92a12 12 0 0 1 12 12z"
		});

		defs.append("symbol").attr({
			id: "icon-plus-circle",
			viewBox: "0 0 512 512",
			width: "17px",
			height: "17px",
			fill: "#4caf50"
		}).append("path").attr({
			class: "plus-circle-svg",
			d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276a12 12 0 0 1-12 12h-92v92a12 12 0 0 1-12 12h-56a12 12 0 0 1-12-12v-92h-92a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12h92v-92a12 12 0 0 1 12-12h56a12 12 0 0 1 12 12v92h92a12 12 0 0 1 12 12z"
		});
		

		// BOTÃO EXCLUIR
		defs.append("symbol").attr({
			id: "icon-times",
			viewBox: "0 0 512 512",
			width: "17px",
			height: "17px",
			fill: "#f6f6f6"
		}).append("path").attr({
			class: "times-circle-svg",
			d: "M377.6 321.1a12 12 0 0 1 0 17L338 377.6a12 12 0 0 1-17 0L256 312l-65.1 65.6a12 12 0 0 1-17 0L134.4 338a12 12 0 0 1 0-17l65.6-65-65.6-65.1a12 12 0 0 1 0-17l39.6-39.6a12 12 0 0 1 17 0l65 65.7 65.1-65.6a12 12 0 0 1 17 0l39.6 39.6a12 12 0 0 1 0 17L312 256z"
		});

		defs.append("symbol").attr({
			id: "icon-times-circle",
			viewBox: "0 0 512 512",
			width: "17px",
			height: "17px",
			fill: "#d15b47"
		}).append("path").attr({
			class: "times-circle-svg",
			d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1a12 12 0 0 1 0 17L338 377.6a12 12 0 0 1-17 0L256 312l-65.1 65.6a12 12 0 0 1-17 0L134.4 338a12 12 0 0 1 0-17l65.6-65-65.6-65.1a12 12 0 0 1 0-17l39.6-39.6a12 12 0 0 1 17 0l65 65.7 65.1-65.6a12 12 0 0 1 17 0l39.6 39.6a12 12 0 0 1 0 17L312 256z"
		});
	};
  
	const fnBuildNodes = (nodeOrigin:any) => {
		/*
    this builds up the real/fake nodes and links needed
    - a node on the "spine" can be like:
      - o--->
  
          |
      - o-+->
  
          |
      - o-+->
          |
  
    - a node off a "rib" or "subrib" can be like:
  
      - o--->
  
          \
      - o--->
  
  */
		const node  = nodeOrigin;
		cNodes.push(node);
  
		let cx = 0;
  
		let between = [node, node.connector];
		const nodeLinks = [{
			source: node,
			target: node.connector,
			arrow: true,
			depth: node.depth || 0
		}];
		let prev:any;
		let childLinkCount;
  
		if(!node.parent){
			cNodes.push(prev = {tail: true});
			between = [prev, node];
			nodeLinks[0].source = prev;
			nodeLinks[0].target = node;
			node.horizontal = true;
			node.vertical = false;
			node.depth = 0;
			node.root = true;
			node.totalLinks = [];
		}else{
			node.connector.maxChildIdx = 0;
			node.connector.totalLinks = [];
		}
  
		node.linkCount = 1;
  
		(fnChildren(node) || []).forEach((childOrigin:any, idx:number) => {
			const child = childOrigin;
			child.parent = node;
			child.depth = (node.depth || 0) + 1;
			child.childIdx = idx;
			if(node.region){
				child.region = node.region;
			}else{
				child.region = idx & 1 ? 1 : -1;
			}
			
			child.horizontal = !node.horizontal;
			child.vertical = !node.vertical;
  
			if(node.root && prev && !prev.tail){
				cNodes.push(child.connector = {
					between,
					childIdx: prev.childIdx
				});
				prev = null;
			}else{
				prev = {between, childIdx: cx};
				cNodes.push(child.connector = {between, childIdx: cx});
				cx += 1;
			}
  
			nodeLinks.push({
				source: child,
				target: child.connector,
				depth: child.depth
			} as any);
  
			// recurse capturing number of links created
			childLinkCount = fnBuildNodes(child);
			node.linkCount += childLinkCount;
			between[1].totalLinks.push(childLinkCount);
		});
  
		between[1].maxChildIdx = cx;
  
		Array.prototype.unshift.apply(cLinks, nodeLinks);
  
		// the number of links created byt this node and its children...
		// TODO: use `linkCount` and/instead of `childIdx` for spacing
		return node.linkCount;
	};

	const fnLinePosition = ($:any) => {
		$.attr({
			x1 (d:any) {
				return d.source.x;
			},
			y1 (d:any) {
				return d.source.y;
			},
			x2 (d:any) {
				let newtarget;
				if (d.depth === 0) {
					const lineSize = fnForce.size();
					const width = lineSize[0];
					newtarget= width - (cMargin + cRoot.getBBox().width) - 5;
				}
				return newtarget || d.target.x;
			},
			y2 (d:any) {
				return d.target.y;
			}
		});
	};
  
	const fnNodePosition = ($:any) => {
		// uses an SVG `transform` to position nodes
		$.attr("transform", (d:any) => `translate(${d.x},${d.y})`);
	};

	// the d3.fishbone() public API
	// read-only
	fb1.links = (newLinks:any[]) => {
		if(newLinks){
			cLinks = newLinks;
		}
		return cLinks;
	};
	fb1.nodes = (newNodes:any[]) => {
		if(newNodes){
			cNodes = newNodes;
		}
		return cNodes;
	};
	fb1.force = () => fnForce;
	fb1.defaultArrow = fnArrow;

	return fb1;
} // d3.fishbone
  
export default fishbone;
